import script from "./CRadioGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./CRadioGroup.vue?vue&type=script&lang=ts&setup=true"

import "./CRadioGroup.vue?vue&type=style&index=0&id=66cd3bdc&lang=scss&scoped=true"

import exportComponent from "D:\\Users\\Sean\\Documents\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66cd3bdc"]])

export default __exports__